import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	refinementOptionRecentProjects: {
		id: 'jql-builder-basic.jql-editor.field.picker-wrapper.props-resolver.project.refinement-option-recent-projects',
		defaultMessage: 'Recent projects',
		description: 'Recent projects subtitle in issue navigator refinement dropdown',
	},
});
